<template>
  <div class="ept-search">
    <input type="text" class="ept-search__input" :placeholder="placeholder" v-model.trim="internalValue" @keyup="emitChange">

    <div class="mt-2 mr-2 absolute right-0 top-0 text-lg">
      <i class="icon far fa-search"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Buscar'
    },

    value: {
      type: String,
      default: ''
    },
  },

  data: () => ({
    internalValue: null
  }),

  mounted() {
    if (this.value) {
      this.internalValue = this.value
    }
  },

  watch: {
    value() {
      if (this.value === this.internalValue) return

      this.internalValue = this.value
    }
  },

  methods: {
    emitChange() {
      this.$nextTick(() => this.$emit('input', this.internalValue))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~stylesheets/vars";

.ept-search {
  @apply relative;

  &__input {
    @apply w-full;
    @apply text-gray-900;
    @apply text-sm;
    @apply rounded;
    @apply border;
    border-color: $stroke-gray;
    @apply outline-none;
    @apply p-2;

    &:focus {
      border-color: $blue-light;
    }
  }

  .icon {
    color: $blue-light;
  }
}
</style>
